import Echo from 'laravel-echo'
import config from '../config'

window.Pusher = require('pusher-js')

const echo = new Echo({
  broadcaster: 'pusher',
  key: config.pusherKey,
  cluster: config.pusherCluster,
  forceTLS: true,
  namespace: 'App.Events'
})

export default echo
